import { TimeSeriesDisableRange } from 'utils/timeseries/TimeSeriesDisableRange';
import { PortfolioReturnsDataPortfolioValues } from './PortfolioReturnsDataPortfolioValues';
import { PortfolioReturnsDataTimeSeriesItem } from './PortfolioReturnsDataTimeSeriesItem';
import { PortfolioReturnsDataInitPortfolioValues } from './PortfolioReturnsDataInitPortfolioValues';
import {
    WidgetStreamState,
    StreamTimeSeriesState,
} from 'widgets/store/stream/WidgetStreamState';

export type PortfolioReturnsStreamState =
    WidgetStreamState<PortfolioReturnsDataState>;

export interface PortfolioReturnsDataState
    extends StreamTimeSeriesState<PortfolioReturnsDataTimeSeriesItem> {
    /*
     * Portfolio values calculated using previous close values on each displayed chart date.
     */
    portfolioValues: PortfolioReturnsDataPortfolioValues[];
    disableRange: TimeSeriesDisableRange[];
    initPortfolioValues?: PortfolioReturnsDataInitPortfolioValues;
}

export const initialPortfolioReturnsDataState: PortfolioReturnsDataState = {
    timeSeries: [],
    portfolioValues: [],
    disableRange: [],
};

export const initialPortfolioReturnsStreamState: PortfolioReturnsStreamState = {
    data: initialPortfolioReturnsDataState,
    messages: [],
};
